import update from "immutability-helper";
import {
  LOGIN_USER_START,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAILURE,
  CHANGE_DATA,
  CHANGE_STEP,
  REGISTRATION_SAVING,
  REGISTRATION_SAVED,
  REGISTRATION_ERROR,
  ADD_AFFILIATE,
  ADD_REFERER,
  SET_AUTHTOKEN,
  FETCH_USER_START,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  //USER_SIGNOUT
  //ORDER_TOKEN,
  ORDER_TOKEN_SAVE,
  ORDER_TOKEN_START,
  ORDER_TOKEN_SUCCESS,
  ORDER_TOKEN_FAILURE,
  ADMIN_SEARCH_USER_START,
  ADMIN_SEARCH_USER_SUCCESS,
  ADMIN_SEARCH_USER_FAILURE,
  ADMIN_LOAD_ID_START,
  ADMIN_LOAD_ID_SUCCESS,
  ADMIN_LOAD_ID_FAILURE,
  LOAD_ID_START,
  LOAD_ID_SUCCESS,
  LOAD_ID_FAILURE,
  REG_EDIT_START,
  REG_EDIT_SUCCESS,
  REG_EDIT_FAILURE,
  SET_SS,
  FETCH_CONVERSION_START,
  FETCH_CONVERSION_SUCCESS,
  FETCH_CONVERSION_FAILURE,
  FETCH_ORDERS_START,
  FETCH_ORDERS_SUCCESS,
  FETCH_ORDERS_FAILURE,
  SAVE_PAYMENT_START,
  SAVE_PAYMENT_SUCCESS,
  SAVE_PAYMENT_FAILURE,
  REQ_BACKUP_START,
  REQ_BACKUP_SUCCESS,
  REQ_BACKUP_FAILURE
} from "../constants/action-types";

const template = {
  //processState: 4,
  // auth: {
  //   token: null,
  //   isAuthenticated: true
  // },
  activeStep: 0,
  salesStep: 1,
  personal_information: {
    full_first_name: "",
    full_last_name: "",
    street_address: "",
    country: { name: "", alpha2Code: "" },
    zip: "",
    city: "",
    nationality: { name: "", alpha2Code: "" },
    birthdate: "",
    email: ""
  },
  document: {
    document_images: {
      frontside: "",
      backside: "",
      selfi: ""
    },
    document_type: "Passport"
  },
  wallet: {
    wallet_address: ""
  },
  investment: {
    Status: "planned",
    token: 200,
    sum: 0,
    display: { token: 200, sum: 0 },
    currency: "ETH"
  },
  confirmation: {
    legal: {
      lg01: {
        aggreement:
          "I am NOT a resident or a citizen of USA, China, Republic of Korea, Canada, New Zealand, Singapore or Cayman Islands.",
        context: ["ico", "no ico country"],
        confirmation: false
        // timestamp: "2018-04-28T11:54:02.736Z"
      },
      lg02: {
        aggreement: "MAKE SURE THAT YOU USE AN ERC20 COMPLIANT WALLET.",
        context: ["ico", "erc20 wallet"],
        confirmation: false
        // timestamp: "2018-04-28T11:54:34.040Z"
      },
      lg03: {
        aggreement:
          "DO NOT SEND ETH FROM AN EXCHANGE. If you send ETH to CRWD Distribution Contract from an exchange account, your CRWD tokens will be allocated to the exchange&#x27;s ETH account and you may never receive or be able to recover your CRWD tokens.",
        context: ["ico", "not from exchange"],
        confirmation: false
        // timestamp: "2018-04-28T11:54:35.097Z"
      },
      lg04: {
        aggreement:
          'I hereby confirm that I have read and fully agree with the &quot;<a target="_blank" rel="noopener noreferrer" href="https://www.crwdnetwork.com/docs/CRWDToken_General_Terms_20191216.pdf">General Terms and Conditions of CRWD Tokens and the CONDA platform</a>&quot;, &quot;<a target="_blank" rel="noopener noreferrer" href="https://www.conda.eu/en/datenschutzerklaerung_at/">Privacy Policy</a>&quot; and &quot;<a target="_blank" rel="noopener noreferrer" href="https://www.crwdnetwork.com/docs/CRWDToken_Distribution_Agreement_%2020191216.pdf">Distribution Agreement</a>&quot;. I am aware of all the associated risks of participation in the CRWD Token distribution and that I am acquiring CRWD Tokens entirely at my own risk.',
        context: [
          "ico",
          "CRWD Token terms",
          "Privacy Policy",
          "Distribution Agreement"
        ],
        confirmation: false
        // timestamp: "2018-04-28T12:26:38.419Z"
      },
      lg05: {
        aggreement:
          "I permit CONDA to process my email address &gt;conda-ico-test-local-001@yopmail.com&gt;&lt; to notify me on my eligibility to purchase CRWD Tokens, changes made to CRWD Token Offer or for security notifications.",
        context: ["ico", "optin CRWD Token notification"],
        confirmation: false
        // timestamp: "2018-04-28T12:26:37.467Z"
      },
      lg06: {
        aggreement:
          "I permit CONDA to process my email address &gt;conda-ico-test-local-001@yopmail.com&gt;&lt; for occasional email news and updates about CONDA, its products &amp; services, promotions, special offers and events.",
        context: ["ico", "not from exchange"],
        confirmation: false
        // timestamp: "2018-04-28T12:26:36.363Z"
      }
    },
    captcha: ""
  },
  admin: {
    searchtext: "conda-ico-test-local-002@yopmail.com",
    ID: {
      fetching: false,
      fetching_error: null,
      fetching_success: false
    }
  }
};

const setDefaultValues = () => {
  template.document.document_id = "IDXXXXXXXXXXXX";
  template.document.document_images.frontside =
    "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAHCAMAAAAlKX2EAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAxQTFRF8+Hg4rOwwjUi////hAuEAwAAAD9JREFUeNqEjkkOwDAIA738/89lErWnRvEFBguwHGVktfLUFgwgyJmJSw/2MxThobPB5fvG/483VXaqZTwCDABvXQFN5S0KogAAAABJRU5ErkJggg==";
  template.document.document_images.backside =
    "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAHCAMAAAAlKX2EAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAxQTFRFzm1n4rOwwjUi////d68GyQAAAEBJREFUeNp0jkkKADAIA2Py/z83Wgv2YFBcBhcEBZKQ5SQkVokE7qZnF9HhAQdb6QcaIKVtAtuNC8ZX6FVxBBgAbzwBRIfVdYwAAAAASUVORK5CYII=";
  template.document.document_images.selfi =
    "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAHCAMAAAAlKX2EAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAxQTFRF4rOwzm1nwjUi////k0bvbwAAAEVJREFUeNpkjkEOwEAIApH5/58Ltod2m2iUjKiSGdsDaEuVhQoqk5GJdp16QAoewQnwrqrju6qORacjqfvAG/y/Gi4BBgBwpAFLSo9bpAAAAABJRU5ErkJggg==";
  template.wallet.wallet_address = "0xde0B295669a9FD93d5F28D9Ec85E40f4cb697BAe";
  template.personal_information.full_first_name = "Max";
  template.personal_information.full_last_name = "Mustermann";
  template.personal_information.street_address = "Musterstr. 1";
  template.personal_information.country.name = "Austria";
  template.personal_information.country.alpha2Code = "AT";
  template.personal_information.zip = "1312";
  template.personal_information.city = "Vienna";
  template.personal_information.nationality.name = "Austria";
  template.personal_information.nationality.alpha2Code = "AT";
  template.personal_information.birthdate = "1970-01-01";
  template.personal_information.email = "conda-ico-test-local-002@yopmail.com";
  template.confirmation.legal.lg01.confirmation = true;
  template.confirmation.legal.lg02.confirmation = true;
  template.confirmation.legal.lg03.confirmation = true;
  template.confirmation.legal.lg04.confirmation = true;
  template.confirmation.legal.lg05.confirmation = true;
  template.confirmation.legal.lg06.confirmation = true;
};

const getMerge = () => {
  if (
    process.env.NODE_ENV === "production" ||
    process.env.REACT_APP_CI === "true"
  ) {
    return template;
  } else {
    setDefaultValues();

    return template;
  }
};

const initialState = update(
  {
    processState: 0,
    activeStep: 0,
    salesStep: 1,
    Status: "",
    auth: {
      token: null,
      isAuthenticated: false,
      login: {
        email: null,
        redirect: null,
        sending: false,
        sending_error: null,
        sending_success: false
      }
    },
    loading: false,
    errorLoading: null,
    isSaving: {
      frontside: false,
      backside: false,
      selfi: false
    },
    saveCounter: 0,
    SavingErrorCounter: 0,
    SavingError: {
      frontside: null,
      backside: null,
      selfi: null
    },
    bounty_referer: "",
    deviceprint: "",
    personal_information: {
      full_first_name: "",
      full_last_name: "",
      street_address: "",
      country: "",
      zip: "",
      city: "",
      nationality: "",
      birthdate: "",
      email: ""
    },
    document: {
      document_type: "Passport",
      document_id: "",
      document_images: {
        frontside: null,
        backside: null,
        selfi: null
      },
      fetching: false,
      fetching_error: null,
      fetching_success: false
    },
    wallet: {
      wallet_address: ""
    },
    investment: {
      Status: "planned",
      OrderDate: null,
      token: 200,
      sum: 0,
      display: { token: 200, sum: 0 },
      currency: "ETH"
    },
    confirmation: {
      legal: {
        lg01: null,
        lg02: null,
        lg03: null,
        lg04: null,
        lg05: null,
        lg06: null
      },
      captcha: ""
    },
    refererby: {},
    order: {
      step: 0,
      saving: false,
      saving_error: null,
      saving_success: false,
      investment: {
        type: "order",
        token: 200,
        sum: 0,
        display: { token: 200, sum: 0 },
        currency: "ETH"
      },
      fetch_conversion: {
        fetching: false,
        fetching_error: null,
        fetching_success: false,
        data: null
      }
    },
    admin: {
      searchtext: "",
      fetching: false,
      fetching_error: null,
      fetching_success: false,
      User: null,
      ID: {
        fetching: false,
        fetching_error: null,
        fetching_success: false
      }
    },
    allorders: {
      fetching: false,
      fetching_error: null,
      fetching_success: false,
      Orders: null
    },
    pay: {
      saving: false,
      saving_error: null,
      saving_success: false
    },
    export: {
      saving: false,
      saving_error: null,
      saving_success: false
    }
  },
  {
    $merge: getMerge()
  }
);
const processState = {
  saved: 0,
  created: 1,
  emailVerified: 2,
  kycDECLINED: 2,
  kycREVIEW: 2,
  kycACCEPTED: 3,
  walletWhitelisted: 4
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER_START:
      return {
        ...state,
        auth: {
          isAuthenticated: false,
          token: null,
          login: {
            email: action.payload.email,
            redirect: action.payload.redirect,
            sending: true,
            sending_error: null,
            sending_success: false
          }
        }
      };
    case LOGIN_USER_SUCCESS:
      return {
        ...state,
        auth: {
          ...state.auth,
          login: {
            ...state.auth.login,
            sending: false,
            sending_success: true
          }
        }
      };
    case LOGIN_USER_FAILURE:
      return {
        ...state,
        auth: {
          ...state.auth,
          login: {
            ...state.auth.login,
            sending: false,
            sending_error: action.payload,
            sending_success: false
          }
        }
      };
    case SET_AUTHTOKEN:
      return {
        ...state,
        auth: { isAuthenticated: true, token: action.payload }
      };
    case CHANGE_DATA:
      if (action.payload.section === "investment") {
        return {
          ...state,
          order: {
            ...state.order,
            investment: action.payload.data
          }
        };
      } else {
        return { ...state, [action.payload.section]: action.payload.data };
      }

    case CHANGE_STEP:
      return { ...state, activeStep: action.payload };
    case REGISTRATION_SAVING:
      const SavingErrorCounterReduce =
        state.SavingError[action.payload] !== null ? -1 : 0;
      return {
        ...state,
        isSaving: { ...state.isSaving, [action.payload]: true },
        saveCounter: state.saveCounter + 1,
        SavingError: { ...state.SavingError, [action.payload]: null },
        SavingErrorCounter: state.SavingErrorCounter + SavingErrorCounterReduce
      };
    case REGISTRATION_SAVED:
      const newIsSaving = { ...state.isSaving, [action.payload]: true };
      const newSaveCounter = state.saveCounter - 1;
      return {
        ...state,
        isSaving: newIsSaving,
        saveCounter: newSaveCounter,
        activeStep:
          newSaveCounter === 0 ? state.activeStep + 1 : state.activeStep,
        processState: newSaveCounter === 0 ? 1 : 0
      };
    case REGISTRATION_ERROR:
      return {
        ...state,
        isSaving: false,
        SavingError: {
          ...state.SavingError,
          [action.payload.part]: action.payload.error
        },
        SavingErrorCounter: state.SavingErrorCounter + 1,
        saveCounter: state.saveCounter - 1
      };
    case ADD_AFFILIATE:
      return {
        ...state,
        refererby: {
          ...state.refererby,
          affiliate: action.payload
        }
      };
    case ADD_REFERER:
      return {
        ...state,
        refererby: {
          ...state.refererby,
          utm: action.payload
        }
      };
    case FETCH_USER_START:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_USER_SUCCESS:
      const { data } = action.payload;
      return {
        ...state,
        loading: false,
        User: data.User,
        AffiliateStatus: data.AffiliateStatus,
        processState: processState[data.status],
        Status: data.status
      };
    case FETCH_USER_FAILURE:
      return {
        ...state,
        loading: false,
        errorLoading: action.payload,
        User: null
      };
    case ORDER_TOKEN_SAVE:
      return {
        ...state,
        order: {
          ...state.order,
          investment: action.payload
        }
      };
    case ORDER_TOKEN_START:
      return {
        ...state,
        order: {
          ...state.order,
          saving: true,
          saving_error: null,
          saving_success: false
        }
      };
    case ORDER_TOKEN_FAILURE:
      return {
        ...state,
        order: {
          ...state.order,
          saving: false,
          saving_error: action.payload,
          saving_success: false
        }
      };
    case ORDER_TOKEN_SUCCESS:
      return {
        ...state,
        order: {
          ...state.order,
          saving: false,
          saving_error: null,
          saving_success: true,
          investment: action.payload[0],
          step: 1
        },
        User: {
          ...state.User,
          Orders: action.payload
        }
      };
    case ADMIN_SEARCH_USER_START:
      return {
        ...state,
        admin: {
          ...state.admin,
          searchtext: action.payload,
          fetching: true,
          fetching_error: null,
          fetching_success: false,
          User: null,
          ID: {
            fetching: false,
            fetching_error: null,
            fetching_success: false,
            documents: null
          }
        }
      };
    case ADMIN_SEARCH_USER_FAILURE:
      return {
        ...state,
        admin: {
          ...state.admin,

          fetching: false,
          fetching_error: action.payload,
          fetching_success: false
        }
      };
    case ADMIN_SEARCH_USER_SUCCESS:
      return {
        ...state,
        admin: {
          ...state.admin,
          fetching: false,
          fetching_error: null,
          fetching_success: true,
          User: action.payload.User
        }
      };
    case ADMIN_LOAD_ID_START:
      return {
        ...state,
        admin: {
          ...state.admin,
          ID: {
            fetching: true,
            fetching_error: null,
            fetching_success: false,
            documents: null
          }
        }
      };
    case ADMIN_LOAD_ID_FAILURE:
      return {
        ...state,
        admin: {
          ...state.admin,
          ID: {
            fetching: false,
            fetching_error: action.payload,
            fetching_success: false
          }
        }
      };
    case ADMIN_LOAD_ID_SUCCESS:
      return {
        ...state,
        admin: {
          ...state.admin,
          ID: {
            ...state.admin.ID,
            fetching: false,
            fetching_error: null,
            fetching_success: true,
            documents: {
              ...state.admin.ID.documents,
              [action.payload.Part]: action.payload.Image
            }
          }
        }
      };
    case LOAD_ID_START:
      return {
        ...state,
        document: {
          ...state.document,
          fetching: true,
          fetching_error: null,
          fetching_success: false,
          documents: null
        }
      };
    case LOAD_ID_FAILURE:
      return {
        ...state,
        document: {
          ...state.document,
          fetching: false,
          fetching_error: action.payload,
          fetching_success: false
        }
      };
    case LOAD_ID_SUCCESS:
      return {
        ...state,

        document: {
          ...state.document,
          fetching: false,
          fetching_error: null,
          fetching_success: true,
          document_images: {
            ...state.document.document_images,
            [action.payload.Part]: action.payload.Image
          }
        }
      };
    case REG_EDIT_START:
      return {
        ...state,
        isSaving: {
          frontside: true,
          backside: true,
          selfi: true
        },
        saveCounter: 0,
        SavingErrorCounter: 0
      };
    case REG_EDIT_FAILURE:
      return {
        ...state,
        isSaving: {
          frontside: false,
          backside: false,
          selfi: false
        },
        saveCounter: 0,
        SavingErrorCounter: 3
      };
    case REG_EDIT_SUCCESS:
      return {
        ...state,
        isSaving: {
          frontside: false,
          backside: false,
          selfi: false
        },
        saveCounter: 3,
        SavingErrorCounter: 0
      };
    case SET_SS:
      return {
        ...state,
        salesStep: action.payload
      };
    case FETCH_CONVERSION_START:
      return {
        ...state,
        order: {
          ...state.order,
          fetch_conversion: {
            fetching: true,
            fetching_error: null,
            fetching_success: false,
            data: null
          }
        }
      };
    case FETCH_CONVERSION_FAILURE:
      return {
        ...state,
        order: {
          ...state.order,
          fetch_conversion: {
            fetching: false,
            fetching_error: action.payload,
            fetching_success: false,
            data: null
          }
        }
      };
    case FETCH_CONVERSION_SUCCESS:
      return {
        ...state,
        order: {
          ...state.order,
          fetch_conversion: {
            fetching: false,
            fetching_error: null,
            fetching_success: true,
            data: action.payload
          }
        }
      };
    case FETCH_ORDERS_START:
      return {
        ...state,
        allorders: {
          ...state.allorders,

          fetching: true,
          fetching_error: null,
          fetching_success: false,
          Orders: null
        }
      };
    case FETCH_ORDERS_FAILURE:
      return {
        ...state,
        allorders: {
          ...state.allorders,

          fetching: false,
          fetching_error: action.payload,
          fetching_success: false,
          Orders: null
        }
      };
    case FETCH_ORDERS_SUCCESS:
      return {
        ...state,
        allorders: {
          ...state.allorders,

          fetching: false,
          fetching_error: null,
          fetching_success: true,
          Orders: action.payload.data.Orders
        }
      };
    case SAVE_PAYMENT_START:
      return {
        ...state,
        pay: {
          ...state.pay,

          saving: true,
          saving_error: null,
          saving_success: false
        }
      };
    case SAVE_PAYMENT_FAILURE:
      return {
        ...state,
        pay: {
          ...state.pay,

          saving: false,
          saving_error: action.payload,
          saving_success: false
        }
      };
    case SAVE_PAYMENT_SUCCESS:
      return {
        ...state,
        pay: {
          ...state.pay,

          saving: false,
          saving_error: null,
          saving_success: true
        }
      };
    case REQ_BACKUP_START:
      return {
        ...state,
        export: {
          ...state.export,
          saving: true,
          saving_error: null,
          saving_success: false
        }
      };
    case REQ_BACKUP_FAILURE:
      return {
        ...state,
        export: {
          ...state.export,
          saving: false,
          saving_error: action.payload,
          saving_success: false
        }
      };
    case REQ_BACKUP_SUCCESS:
      return {
        ...state,
        export: {
          ...state.export,
          saving: false,
          saving_error: null,
          saving_success: true
        }
      };
    default:
      return state;
  }
};
const rootReducer = (state, action) => {
  if (action.type === "USER_SIGNOUT") {
    state = undefined;
    sessionStorage.removeItem("AUTH");
  }

  return appReducer(state, action);
};
export default rootReducer;
